<div class="row productLabelFormPage">
  <div class="mainContent">

    <div class="row">
      <div class="order-view-sec breadcrumbOuter padding-0">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <span>Associate Order</span>
                <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item">
              <span>Order Inventory Management</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="OrderReleaseTop seedReserveCreate">

      <div class="row align-items-start mt-2">
        <div class="col-md-3 material-select withBordr productLabelAccountName">
          <!-- Show dropdown when multiple accounts exist -->
          <ng-select *ngIf="locationOpenMode === 0"
                     name="ddlLocation"
                     [items]="locationData"
                     class="custom-select-grower grower-add-drop"
                     [virtualScroll]="true"
                     bindValue="locationId"
                     placeholder="Associate Location:"
                     [(ngModel)]="formdata.locationId"
                     [loading]="locationDataLoading"
                     (change)="onLocationDdlChange($event)"
                     [closeOnSelect]="true"
                     data-testid="ddl-location-search"
                     [searchFn]="locationSearchFn"
                     [ngClass]="{'no-border': formdata.locationId}">

            <!-- Custom selected label -->
            <ng-template ng-label-tmp let-item="item">
              <div class="selected-template">
                <p class="greenColor m-0">{{ item.associateName }}</p>
                {{ item.address1 }}{{ item.address2 ? ', ' + item.address2 : '' }}, {{ item.city }}, {{ item.state }} - {{ item.zipCode }}<br />
                {{ item.associatePhoneNumber }}<br />
                Account #: {{ item.associateAccountNumber }}
              </div>
            </ng-template>

            <!-- Dropdown option template -->
            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
              <div class="dropdown-template" [attr.data-testid]="'ddl-location-option_'+index">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="name greenColor" [ngOptionHighlight]="search">
                      {{item.associateName}}
                    </h4>
                    <p class="address m-0" [ngOptionHighlight]="search">
                      {{item.address1}}{{ item.address2 ? ', ' + item.address2 : '' }}, {{item.city}}, {{item.state}} - {{item.zipCode}}
                    </p>
                    <p class="phoneNo m-0" [ngOptionHighlight]="search">
                      {{item.associatePhoneNumber}}
                    </p>
                    <p class="grower-nos m-0">
                      <span class="grower-gln" [ngOptionHighlight]="search">
                        Account #: {{item.associateAccountNumber}}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>

          <!-- Show as static text when only one account exists -->
          <div *ngIf="locationOpenMode === 1">
            <label class="account-label">Associate Location:</label>
            <div class="selected-template">
              <p class="greenColor m-0">{{ locationData[0].associateName }}</p>
              {{ locationData[0].address1 }}{{ locationData[0].address2 ? ', ' + locationData[0].address2 : '' }}, {{ locationData[0].city }}, {{ locationData[0].state }} - {{ locationData[0].zipCode }}<br />
              {{ locationData[0].associatePhoneNumber }}<br />
              Account #: {{ locationData[0].associateAccountNumber }}
            </div>
          </div>
          <div *ngIf="locationOpenMode === 2">
            <p>No Associate location is assigned to manage the Crop Inventory</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row filterButtonsContainer">
      <!-- Filter Section -->
      <app-filter [(optionsData)]="filterOptionsData" [isDisableWholeFilter]="isDisableWholeFilter" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)" class="filterSection"></app-filter>
      <!-- Buttons Section -->
      <div class="buttonSection">
        <button mat-raised-button class="btns exportBtn" [disabled] ="locationOpenMode === 2 || isDisableWholeFilter" (click)="exportData()">Export</button>
        <button *ngIf="!readOnlyAccess" class="btns addReservation" [disabled]="readOnlyAccess || !formdata.locationId" mat-raised-button color="primary" (click)="addInventoryRow()" >
          Add Inventory Line
        </button>
      </div>
    </div>   
     <div class="tableOuterContainer">
      <div class="d-flex justify-content-between align-items-center flex-md-row flex-column-reverse deleteBarSection">
        <div class="productsection d-flex align-items-center"
             [ngStyle]="!readOnlyAccess && selectedCount > 0 ? {'visibility': 'visible'} : {'visibility': 'hidden'}">
          <div class="col-md-2 d-flex align-items-center">
            <mat-checkbox #Allcheck class="custom-checkbox select-all-check mt-0"
                          [checked]="selectedCount == InventoryDataSource.data.length"
                          [indeterminate]="InventoryDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount < InventoryDataSource.data.length)"
                          [style.display]="readOnlyAccess ? 'none' : ''" (change)="enableAllCheckBoxes(Allcheck._checked);"
                          matTooltip="Select All Items" [matTooltipPosition]="'above'"
                          data-testid="ddl-select-all-product"></mat-checkbox>
  
            <div class="product-tools-outer" *ngIf="showTabs">
              <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">
  
                <div class="tab-bar">
                  <ul>
                    <li (click)="tabNode='delete'" class="seperator" matTooltip="Delete Item(s) from Inventory"
                        [matTooltipPosition]="'above'">
                      <i class="icon-ico-trash"></i>
                    </li>
                  </ul>
                </div>
  
                <div class="tab-content">
                  <div *ngIf="tabNode==='delete'" class="delete-product">
                    <div class="tab-content-heading">
                      Delete Item(s) from Inventory
                    </div>
                    <div class="tab-content-detail">
                      <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                      <div class="btn-area">
                        <button mat-raised-button class="btns normal-large-btn" color="primary"
                                (click)="deleteSelectedItems(true)">
                          Yes
                        </button>
                        <button mat-raised-button class="btns normal-large-btn" color="primary"
                                (click)="deleteSelectedItems(false)">
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
       <table mat-table multiTemplateDataRows [dataSource]="InventoryDataSource" class="productTable matTables seedReservationTable">
         <!-- Checkbox Column -->
         <ng-container matColumnDef="select" >
           <th mat-header-cell *matHeaderCellDef>  </th>
           <td mat-cell *matCellDef="let element">
             <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck class="custom-checkbox"
                           [style.display]="'contents'"
                           [disabled]="readOnlyAccess"
                           (change)="enableCheckBoxSingle(SingleCheck._checked,element)"
                           [(ngModel)]="element.selected"
                           [attr.data-testid]="'ddl-specific-check_'+i"></mat-checkbox>
           </td>
           <td mat-footer-cell *matFooterCellDef> </td>
         </ng-container>

         <ng-container matColumnDef="cropType">
           <th mat-header-cell *matHeaderCellDef> Crop Type </th>
           <td mat-cell *matCellDef="let element">
             <!-- If productLineName exists -->
             <p class="d-block d-md-none fontSize mb-2">Crop Type</p>

             <span *ngIf="!element.isNewLine">
               {{ element.cropTypeDesc }}
             </span>

             <ng-select *ngIf="element.isNewLine"
                        [items]="cropTypeMasterList"
                        class="custom-select-grower grower-add-drop productLabelDropdown"
                        [virtualScroll]="true"
                        bindLabel="cropTypeDesc"
                        [disabled]="readOnlyAccess"
                        bindValue="cropTypeCode"
                        [placeholder]="element.cropTypeCode ? '' : 'Select Crop Type'"
                        [(ngModel)]="element.cropTypeCode"
                        [closeOnSelect]="true"
                        [searchFn]="filterSearchFnForCropType"
                        (change)="onCropTypeOrVarietyChange(element, 'cropType')">
             </ng-select>
           </td>

         </ng-container>
         <ng-container matColumnDef="variety">
           <th mat-header-cell *matHeaderCellDef> Variety </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2"> Variety</p>

             <span *ngIf="!element.isNewLine">
               {{ element.brand }}
             </span>

             <ng-select *ngIf="element.isNewLine"
                        [items]="element.varietyFilteredList"
                        class="custom-select-grower grower-add-drop productLabelDropdown"
                        [virtualScroll]="true"
                        bindLabel="variety"
                        [disabled]="readOnlyAccess || !element.cropTypeCode"
                        bindValue="variety"
                        [placeholder]="element.brand ? '' : 'Select Variety'"
                        [(ngModel)]="element.brand"
                        [closeOnSelect]="true"
                        [searchFn]="filterSearchFnForVariety"
                        (change)="onCropTypeOrVarietyChange(element, 'variety')">
             </ng-select>
             <div *ngIf="element.hasMarketingBrandError" class="text-danger large">
               Please select Variety.
             </div>
           </td>
         </ng-container>

         <!-- Marketing Brand Display Column (Read-Only) -->
         <ng-container matColumnDef="marketingBrand">
           <th mat-header-cell *matHeaderCellDef> Marketing Brand </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2">Marketing Brand</p>
             <span class="readonly-value">{{ element.marketingBrand }}</span>
           </td>
         </ng-container>

         <!-- Units Column -->
         <ng-container matColumnDef="quantity">
           <th mat-header-cell *matHeaderCellDef> Quantity </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2">Quantity </p>

             <div *ngIf="!readOnlyAccess">
               <button (click)="geuValueChange('decrease',element);" [disabled]="readOnlyAccess" class="plus-minus-btn minusBtn" [attr.data-testid]="'decrease-' + element.cropTypeCode"> - </button>
               <input [readonly]="readOnlyAccess" type="text" class="geu-txt decimal-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)" [(ngModel)]="element.quantity" maxlength="6" appNumbersOnly [attr.data-testid]="'txt-specific-qty_'+i" />
               <button (click)="geuValueChange('increase',element)" class="plus-minus-btn plusBtn" [disabled]="readOnlyAccess" [attr.data-testid]="'increase-' + element.cropTypeCode"> + </button>
             </div>
             <div *ngIf="readOnlyAccess">
               <span class="readonly-value">{{ element.quantity || 0 }}</span>
             </div>
           </td>
         </ng-container>

         <!-- Committed Qty Column (Read-Only) -->
         <ng-container matColumnDef="committedQty">
           <th mat-header-cell *matHeaderCellDef> Committed Qty </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2">Committed Qty</p>
             <span class="readonly-value">{{ element.committedQty || 0 }}</span>
           </td>
         </ng-container>

         <!-- Available Qty Column (Read-Only) -->
         <ng-container matColumnDef="availableQty">
           <th mat-header-cell *matHeaderCellDef> Available Qty </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2">Available Qty</p>
             <span class="readonly-value">{{ element.availableQty || 0 }}</span>
           </td>
         </ng-container>

         <!-- UOM Column (Read-Only) -->
         <ng-container matColumnDef="uom">
           <th mat-header-cell *matHeaderCellDef> UOM </th>
           <td mat-cell *matCellDef="let element">
             <p class="d-block d-md-none fontSize mb-2">UOM</p>
             <span class="readonly-value">{{ element.uom }}</span>
           </td>
         </ng-container>
         <ng-container matColumnDef="expandedDetail">
           <td mat-cell class="p-0" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
             <div class="inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
               <div class="row">
                 <div class="col-md-9">
                   <ol class="error-list">
                     <li *ngFor="let err of element.lineErrors.errors">
                       {{err.error}}
                   </ol>
                 </div>
               </div>
             </div>
           </td>
         </ng-container>

         <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
         <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"></tr>
         <tr mat-row
             *matRowDef="let element; columns: ['expandedDetail']; when: isExpansionRow"
             class="example-detail-row">
         </tr>
       </table>
       <div *ngIf="InventoryDataSource == undefined || (InventoryDataSource && InventoryDataSource.data.length == 0)" class="noDataMsg">
         <p class="padding-b47">No Record Found.</p>
       </div>
     </div>
  </div>

  <div class="SeedFulfillBtnSec">

    <div class="row d-flex align-items-center flex-md-row flex-column-reverse">
      <div class="col-md-8 col-12 p-1 d-flex d-md-block">
        <button mat-raised-button *ngIf="!readOnlyAccess" class="btns mobileView" (click)="saveOrder()"
                [style.display]="'inline-block'" [disabled]="isPlaceOrderDisable">
          Update Inventory
        </button>
        <button mat-raised-button class="btns w140" color="primary" [disabled]="!formdata.locationId"
                (click)="refreshPage()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
